<template>
  <va-form :id="id" :item="item">
    <v-row justify="center">
      <v-col sm="6">
        <base-material-card>
          <template v-slot:heading>
            <div class="display-2">
              {{ title }}
            </div>
          </template>
          <v-card-text>
            <va-text-input source="mws_configuration_id"></va-text-input>
            <va-text-input source="status"></va-text-input>
            <va-text-input source="revenue"></va-text-input>
            <va-text-input source="fba_fee"></va-text-input>
            <va-text-input source="product_cog"></va-text-input>
            <va-text-input source="refund"></va-text-input>
            <va-text-input source="advertising_cost"></va-text-input>
            <va-text-input source="other_cost"></va-text-input>
            <va-text-input source="net_profit"></va-text-input>
            <va-text-input source="created_at"></va-text-input>
          </v-card-text>
          <va-save-button></va-save-button>
        </base-material-card>
      </v-col>
    </v-row>
  </va-form>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
